/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getNegotiationContracts,
  getNegotiationTileDataAction,
  setNegotiationContractStatus,
} from "../../../redux/Action/Action";
import { RootState } from "../../../redux/Reducer";
import NegotiationContractTile from "./NegotiationContractTile";
import { CREATE_NEGOTIATION_SUCCESS } from "../../../redux/Action/actionTypes";

const OverviewPage: React.FC = () => {
  const dispatch = useDispatch();
  const negotiationContractsArr = useSelector(
    (state: RootState) => state.dashboardData.negotiationData
  );

  // calling all negotiation contracts ie ALL api call
  useEffect(() => {
    dispatch(getNegotiationContracts());
  }, []);

  // month name formmatter method for negotaition date and implementation 
  const getMonthAbbreviation = (monthNumber: number): string => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return monthNames[monthNumber - 1] ?? "--";
  };

  // calling this once user click on negotiaiton tile card from overview for all flows 
  const negotiationContractDraftHandler = (contractDetails: any) => {
    let contractStatus = "inReview";
    if (contractDetails.isSavedForLater) {
      contractStatus = "draft";
    } else if (contractDetails.status === "In Progress") {
      contractStatus = "inProgress";
    } else if (contractDetails.status === "Completed") {
      contractStatus = "completed";
    }

    dispatch(
      getNegotiationTileDataAction({
        id: contractDetails.id,
        contractStatus,
      })
    );
    dispatch(setNegotiationContractStatus(contractStatus));
    dispatch({
      type: CREATE_NEGOTIATION_SUCCESS,
      payload: { state: true, ID: contractDetails.id },
    });
  };

  return (
    <div className="row">
      {negotiationContractsArr.length > 0 &&
        negotiationContractsArr.map((contractDetails: any) => {
          let monthName = getMonthAbbreviation(
            contractDetails.negotiationDateMonth
          );
          return (
            <NegotiationContractTile
              key={contractDetails.id}
              negotiationContractDraftHandler={
                negotiationContractDraftHandler
              }
              contractDetails={contractDetails}
              monthName={monthName}
            />
          );
        })}
    </div>
  );
};

export default OverviewPage;
